export type YoutubeSubscriptionPeriod = 3 | 6 | 12;
export type YoutubeIssuanceType = "new" | "reissue";

export interface YoutubeCommentPreset {
  tag: string;
  content: string;
}

export const getYoutubeSubscriptionPeriod = (
  servsubsid?: number,
): YoutubeSubscriptionPeriod => {
  switch (servsubsid) {
    case 37000:
      return 6;
    case 37050:
      return 12;
    case 37080:
    default:
      return 3;
  }
};

export const createYoutubeCommentPreset = ({
  issuanceType,
  round,
  subscriptionPeriod,
  account,
  roundStartDate,
}: {
  issuanceType: YoutubeIssuanceType;
  round: number;
  subscriptionPeriod: YoutubeSubscriptionPeriod;
  account: string;
  roundStartDate: string;
}): YoutubeCommentPreset => {
  if (issuanceType === "reissue") {
    return {
      tag: `등록정보_재발급 (${round}/${subscriptionPeriod})`,
      content: `적용 계정 : ${account.trim()}\n${round}회차 시작일 : ${roundStartDate}`,
    };
  }

  return {
    tag: `등록정보_성공(1/${subscriptionPeriod})`,
    content: `적용 계정 : ${account.trim()}`,
  };
};
